import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Box } from '@mui/material'
import { DateUtils, LanguageUtils, Utils } from '@pbt/pbt-ui-components'

import type { InventoryOrder } from '~/api/graphql/generated/types'
import { LabelValue } from '~/components/common/labels/LabelValue'
import { getInventoryDistributors } from '~/store/reducers/constants'

interface OrderItemsPageHeaderLabelsProps {
  inventoryOrder: InventoryOrder
}

export const OrderItemsPageHeaderLabels = ({
  inventoryOrder: { orderedDate, distributor, externalCreatorEmail },
}: OrderItemsPageHeaderLabelsProps) => {
  const { t } = useTranslation('Admin')

  const InventoryDistributors = useSelector(getInventoryDistributors)
  const distributorConstantName = Utils.getConstantName(
    distributor.id,
    InventoryDistributors,
  )
  const distributorDisplayName = LanguageUtils.getConstantTranslatedName(
    distributor.id,
    InventoryDistributors,
  )

  return (
    <Box alignItems="center" display="flex" gap={2}>
      <LabelValue
        label={t('Admin:CATALOG.ORDERS.ORDERED_DATE_LABEL')}
        value={DateUtils.formatDate(orderedDate)}
      />
      <LabelValue
        label={t('Admin:CATALOG.ORDERS.SUPPLIER_LABEL')}
        value={
          distributorConstantName === 'Other'
            ? distributor.name
            : distributorDisplayName
        }
      />
      <LabelValue
        label={t('Admin:CATALOG.ORDERS.ORDERED_BY_LABEL')}
        value={externalCreatorEmail}
      />
    </Box>
  )
}
